import script from "./File.vue?vue&type=script&setup=true&lang=ts"
export * from "./File.vue?vue&type=script&setup=true&lang=ts"

import "./File.vue?vue&type=style&index=0&id=5498ec2f&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5498ec2f"]])

export default __exports__